// Entry point: mounts React, prints the resolved endpoints, registers the SW.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SERVER_URL, WS_URL } from './api';
import { APP_NAME, APP_TAGLINE } from './branding';

document.title = APP_NAME;
const desc = document.querySelector('meta[name="description"]');
if (desc) desc.setAttribute('content', `${APP_NAME} — ${APP_TAGLINE}`);
const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
if (appleTitle) appleTitle.setAttribute('content', APP_NAME);

// Startup diagnostics — VITE_SERVER_URL / VITE_WS_URL are baked in at build
// time, so print exactly what this page will talk to.
console.info(
  `[HomeCloud] API ${SERVER_URL} · WS ${WS_URL} · page ${window.location.origin}`
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for installability + offline shell.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
  });
}
